export default __webpack_public_path__ + "static/media/Convenient for everyone.3c629d92.jpg";